import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// The type scale from tokens.css. Without this, tailwind-merge reads `text-caption`
// as a colour and drops a `text-muted-foreground` next to it (or the other way round).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['display', 'display-sm', 'heading', 'title', 'body', 'compact', 'caption', 'label'] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
